import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NavService {
  private navStatus = new BehaviorSubject<boolean>(true);
  private isMobileNav = new BehaviorSubject<boolean>(false);
  private isMobileNavOpen = new BehaviorSubject<boolean>(false);
  private sideNav = new BehaviorSubject<any>({ toogle: false });
  private refreshSubject = new BehaviorSubject<string | null>(null)
  constructor() { }
  setIsMobileNav(op: any) {
    this.isMobileNav.next(op);
  }
  getIsMobileNav(): Observable<any> {
    return this.isMobileNav.asObservable();
  }
  setIsMobileNavOpen(op: any) {
    this.isMobileNavOpen.next(op);
  }
  getIsMobileNavOpen(): Observable<any> {
    return this.isMobileNavOpen.asObservable();
  }
  openSideNav(op: any) {
    this.sideNav.next(op);
  }
  getSideNav(): Observable<any> {
    return this.sideNav.asObservable();
  }
  updateNav(type: boolean) {
    this.navStatus.next(type);
  }
  isNavOpen(): Observable<any> {
    return this.navStatus.asObservable();
  }
  triggerRefresh(module: string) {
    this.refreshSubject.next(module);
  }

  onRefresh(): Observable<string | null> {
    return this.refreshSubject.asObservable();
  }
  NavList() {
    let nav = [
      {
        label: 'Dashboard',
        icon: 'icon-report',
        url: '/dashboard',
        always: true,
      },
      {
        label: 'Trips',
        icon: 'icon-trip',
        url: '/trip',
        claimType: 'TRP_VIEW_TRIP',
      },
      {
        label: 'Expenses',
        icon: 'icon-expense',
        url: '/expense',
        claimType: [
          'EXP_VIEW_EXPENSE',
          'EXP_VIEW_MY_EXPENSE_LIST',
          'EXP_VIEW_RM_EXPENSE_LIST',
          'EXP_APPROVE_ACCOUNT_EXPENSE',
        ],
      },
      {
        label: 'Trips Approval',
        icon: 'icon-trip-approved',
        url: '/request/trip',
        isDirector: true,
      },
      {
        label: 'Expenses Approval',
        icon: 'icon-expense',
        url: '/request/expense',
        isDirector: true,
      },
      {
        label: 'Advanced Money',
        icon: 'icon-advance',
        url: '/advanced-money',
        // always: true,
        claimType: 'ADV_VIEW_ADVANCE_MONEY'
      },
      {
        label: 'Reports',
        icon: 'icon-advance',
        url: '/reports',
        claimType: 'RPT_VIEW_MENU_REPORT'
      },
      {
        label: 'Settings',
        icon: 'icon-settings',
        url: '/settings',
        always: true,
      },
      // {
      //   label: 'My Expense Report',
      //   icon: 'icon-expense',
      //   url: '/reports/my-expense-report',
      //   claimType: 'RPT_MY_EXPENSE_REPORT',
      // },
      // {
      //   label: 'Team Expense Report',
      //   icon: 'icon-expense',
      //   url: '/reports/team-expense-report',
      //   claimType: 'RPT_TEAM_EXPENSE_REPORT',
      // },
    ];
    return nav;
  }
  ReportsNavList() {
    let nav = [
      {
        label: 'User Report',
        icon: 'fa-users',
        url: '/reports/user',
        claimType: 'RPT_VIEW_USER_REPORT',
      },
      {
        label: 'Expense Report',
        icon: 'fa-file-text-o',
        url: '/reports/expense',
        claimType: 'RPT_VIEW_EXPENSE_REPORT',
      },
      {
        label: 'Expense Reimburse Report',
        icon: 'fa-file-text-o',
        url: '/reports/expense-reimburse',
        claimType: 'RPT_VIEW_EXPENSE_REIMBURSEMENT_REPORT',
      },
      {
        label: 'Travel Report',
        description: 'Business trips and travel costs',
        icon: 'fa-plane',
        url: '/reports/travel',
        disabled: true,
        claimType: 'RPT_VIEW_TRAVEL_REPORT',
      },
      {
        label: 'Expense Details Report',
        icon: 'fa-file-text-o',
        url: '/reports/expense-details-report',
        claimType: 'RPT_VIEW_EXPENSE_DETAILS_REPORT',
      },
      {
        label: 'Team Expense Overview',
        icon: 'fa-file-text-o',
        url: '/reports/team-expense-report',
        claimType: 'RPT_TEAM_EXPENSE_REPORT',
      },
      {
        label: 'My Expense Overview',
        icon: 'fa-file-text-o',
        url: '/reports/my-expense-report',
        claimType: 'RPT_MY_EXPENSE_REPORT',
      },
      {
        label: 'My Trip Overview',
        icon: 'fa-users',
        description: 'Business trips and travel costs',
        url: '/reports/trips/me',
        claimType: 'RPT_MY_TRIP_REPORT',
      },
      {
        label: 'Team Trip Overview',
        description: 'Business trips and travel costs',
        icon: 'fa-users',
        url: '/reports/trips/team',
        claimType: 'RPT_TEAM_TRIP_REPORT',
      },

    ];
    return nav;
  }
  SettingsNavList() {
    let nav = [
      {
        label: 'Basic Information',
        icon: 'assets/images/icon-1.svg',
        url: '/settings/my-account',
        claimType: 'SETT_VIEW_BASIC_INFORMATION',
      },
      {
        label: 'Travel Documents',
        icon: 'assets/images/icon-2.png',
        url: '/settings/travel-documents',
        claimType: 'SETT_VIEW_TRAVEL_DOCUMENTATION',
      },
      {
        label: 'Support Request',
        icon: 'assets/images/icon-2.png',
        url: '/settings/support-request',
        claimType: 'SETT_VIEW_CONTACT_SUPPORT',
      },
      {
        label: 'Organization',
        url: '/settings/organization',
        claimType: 'ORG',
        child: [
          {
            label: 'Organization Profile',
            icon: 'assets/images/org.png',
            url: '/settings/organization/profile',
            claimType: 'ORG_VIEW_ORGANIZATION',
          },
          {
            label: 'Expense Categories',
            icon: 'assets/images/category.png',
            url: '/settings/organization/expense-categories',
            claimType: 'EXP_CAT_VIEW_EXPENSE',
          },
          {
            label: 'Branch Master',
            icon: 'assets/images/branch_img.svg',
            url: '/settings/organization/branch-master',
            claimType: 'EXP_CAT_VIEW_EXPENSE',
          },
          {
            label: 'Vendor Master',
            icon: 'assets/images/employee.png',
            url: '/settings/organization/vendors',
            claimType: 'VND_VIEW_VENDOR',
          },
          // {
          //   label: 'GST',
          //   icon: 'assets/images/tax.png',
          //   url: '/settings/organization/taxes',
          //   claimType:'GST_VIEW_GST'
          // },
        ],
      },
      {
        label: 'Employees & Controls',
        url: '/settings/controls',
        claimType: 'EMPLOYEE_CONTROLS',
        child: [
          {
            label: 'Employees',
            icon: 'assets/images/employee.png',
            url: '/settings/controls/employees',
            claimType: 'USR_VIEW_USERS',
          },
          {
            label: 'Roles & Permission',
            icon: 'assets/images/roles.png',
            url: '/settings/controls/roles-and-permission',
            claimType: 'ROLES_VIEW_ROLES',
          },
          {
            label: 'Departments',
            icon: 'assets/images/dept.png',
            url: '/settings/controls/departments',
            claimType: 'DPT_VIEW_DEPARTMENT',
          },
          {
            label: 'Policies',
            icon: 'assets/images/policy.png',
            url: '/settings/controls/policies',
            claimType: 'PLC_VIEW_POLICY',
          },
        ],
      },
      {
        label: 'Customization',
        url: '/settings/customization',
        claimType: 'CUSTOMIZATION',
        child: [
          {
            label: 'Grade Management',
            icon: 'assets/images/grade.png',
            url: '/settings/customization/grade-management',
            claimType: 'GRD_VIEW_GRADE',
          },
          {
            label: 'Vehicle Management',
            icon: 'assets/images/location.png',
            url: '/settings/customization/vehicle-management',
            claimType: 'VHCL_VIEW_VEHICLE',
          },
          // {
          //   label: 'Multi Level Approvals',
          //   icon: 'assets/images/like.png',
          //   url: '/settings/customization/multi-level-approvals',
          // },
        ],
      },
      {
        label: 'Integrations',
        disabled: true,
        claimType: 'INTEGRATIONS',
        child: [
          {
            label: 'SAP',
            icon: 'assets/images/icon-1.svg',
            url: '/settings/grade-management',
            claimType: 'SAP',
          },
          {
            label: 'HRMS',
            icon: 'assets/images/icon-2.png',
            url: '/settings/vehicle-management',
            claimType: 'HRMS',
          },
        ],
      },
      {
        label: 'Logs',
        url: '/settings/logs',
        claimType: 'LOGS',
        child: [
          {
            label: 'Login Audits',
            icon: 'assets/images/icon-1.svg',
            url: '/settings/logs/login-audits',
            claimType: 'LOGS_VIEW_LOGIN_AUDITS',
          },
          {
            label: 'Error Logs',
            icon: 'assets/images/icon-2.png',
            url: '/settings/logs/error-logs',
            claimType: 'LOGS_VIEW_ERROR_LOGS',
          },
        ],
      },
    ];
    return nav;
  }
  adminNavList() {
    let nav = [
      {
        label: 'Dashboard',
        icon: 'icon-report',
        url: '/admin/dashboard',
      },
      {
        label: 'Trip Request',
        icon: 'icon-trip',
        url: '/admin/trip-request',
      },
      {
        label: 'Expense Request',
        icon: 'icon-expense',
        url: '/admin/expense-request',
      },
      {
        label: 'Reports',
        icon: 'icon-advance',
        url: '/admin/reports',
      },
      {
        label: 'Settings',
        icon: 'icon-settings',
        url: '/admin/settings',
      },
    ];
    return nav;
  }
  adminSettingsNavList() {
    let nav = [
      {
        label: 'Organization',
        url: '/admin/settings/organization',
        child: [
          {
            label: 'Organization Profile',
            icon: 'assets/images/org.png',
            url: '/admin/settings/organization/profile',
          },
          {
            label: 'Expense Categories',
            icon: 'assets/images/category.png',
            url: '/admin/settings/organization/expense-categories',
          },
          {
            label: 'GST',
            icon: 'assets/images/tax.png',
            url: '/admin/settings/organization/taxes',
          },
        ],
      },
      {
        label: 'Employees & Controls',
        url: '/admin/settings/controls',
        child: [
          {
            label: 'Employees',
            icon: 'assets/images/employee.png',
            url: '/admin/settings/controls/employees',
          },
          {
            label: 'Roles & Permission',
            icon: 'assets/images/roles.png',
            url: '/admin/settings/controls/roles-and-permission',
          },
          {
            label: 'Departments',
            icon: 'assets/images/dept.png',
            url: '/admin/settings/controls/departments',
          },
          {
            label: 'Policies',
            icon: 'assets/images/policy.png',
            url: '/admin/settings/controls/policies',
          },
        ],
      },
      {
        label: 'Customization',
        url: '/admin/settings/customization',
        child: [
          {
            label: 'Grade Management',
            icon: 'assets/images/grade.png',
            url: '/admin/settings/customization/grade-management',
          },
          {
            label: 'Vehicle Management',
            icon: 'assets/images/location.png',
            url: '/admin/settings/customization/vehicle-management',
          },
          {
            label: 'Multi Level Approvals',
            icon: 'assets/images/like.png',
            url: '/admin/settings/customization/multi-level-approvals',
          },
        ],
      },
      {
        label: 'Integrations',
        disabled: true,
        child: [
          {
            label: 'SAP',
            icon: 'assets/images/icon-1.svg',
            url: '/admin/settings/grade-management',
          },
          {
            label: 'HRMS',
            icon: 'assets/images/icon-2.png',
            url: '/admin/settings/vehicle-management',
          },
        ],
      },
    ];
    return nav;
  }
  employeeNavList() {
    let nav = [
      {
        label: 'Dashboard',
        icon: 'icon-report',
        url: '/employee/dashboard',
      },
      {
        label: 'My Trips',
        icon: 'icon-trip',
        url: '/employee/my-trips',
      },
      {
        label: 'My Expenses',
        icon: 'icon-expense',
        url: '/employee/my-expenses',
      },

      {
        label: 'My Settings',
        icon: 'icon-settings',
        url: '/employee/my-settings',
      },
    ];
    return nav;
  }
  employeeSettingsNavList() {
    let nav = [
      {
        label: 'Basic Information',
        icon: 'assets/images/icon-1.svg',
        url: '/employee/my-settings/basic-information',
      },
      {
        label: 'Travel Documents',
        icon: 'assets/images/icon-2.png',
        url: '/employee/my-settings/travel-documents',
      },
    ];
    return nav;
  }
}
